import { LitElement, html, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility, containers, grid, sidebar } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { dateToMaybeRange, currencyFormatter } from '../../utilities/eventUtilities';
import { arrowBack, arrow } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInEventLocations extends LitElement {
    static properties = {
        name: { type: String },
        eventData: { type: Array, state: true },
        touringEventText: { type: String },
        config_hardlinks: { type: Object, reflect: true },
        hardlinks: { type: Object, state: true },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-event-locations-update`, this._updateEventData.bind(this));
        console.log(this.config_hardlinks);
        if (this.config_hardlinks) {
            this.hardlinks = this.config_hardlinks;
        }
        console.log(this.hardlinks);
        this.config_hardlinks = null;
        //await this._fetchAllProvisions();
        //await this._fetchEvents();
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    async firstUpdated() {
        cardLinks(this.shadowRoot);
    }
    render() {
        let main;
        let aside;
        if (this.eventData) {
            let cards = [];
            let location = this.eventData?.location;
            let touringLocation = this.eventData?.locationName;
            let touringLocationLink = this.eventData?.locationUrl;
            let zones = [];
            let searchParams = new URLSearchParams(window.location.search);
            let eventSearch = searchParams.get('eventsearch') ?? '';
            if (eventSearch) {
                eventSearch = `?eventsearch=${encodeURIComponent(eventSearch)}`;
            }
            if (this.eventData?.instances?.length) {
                this.eventData.instances.forEach(instance => {
                    if (instance.zone) {
                        if (!zones.find(z => z.id === instance.zone.id)) {
                            zones.push(instance.zone);
                        }
                    }
                });
            }
            //Need to handle touring events
            if (location) {
                cards.push(html `\n                    <div class="bg_white card card--event">\n                        <div class="container container--threetwo">\n                            <img src="${location.photo1?.publicUrl ?? '/wp-content/themes/ace/assets/fallback_new.jpeg'}" alt="${location.photo1?.altText ?? ''}" />\n                            <allin-alt-block description="${location.photo1?.altText ?? ''}" uid="alt_photo1_${location.id}"></allin-alt-block>\n                        </div>\n                        <div class="card-content">\n                            <a href="${this.hardlinks.listings_locations}/${location.id}${eventSearch}" class="card_target follow"><h3>${location.name}</h3></a>\n                            ${arrow}\n                        </div>\n                    </div>`);
            }
            if (touringLocation) {
                cards.push(html `\n                     <div class="bg_white card card--event">\n                        <div class="container container--threetwo">\n                            <img src="/wp-content/themes/ace/assets/icons/planning_a_visit_yellow.svg" alt="Icon for a touring location showing a map pin with a list inside it" />\n                            <allin-alt-block description="Icon for a touring location showing a map pin with a list inside it" uid="alt_photo1_touring"></allin-alt-block>\n                        </div>\n                        ${touringLocationLink ? html `<div class="card-content">\n                            <a href="${touringLocationLink}" class="card_target follow"><h3>${touringLocation}</h3></a>\n                            ${this.touringEventText ? html `<p>${this.touringEventText}</p>` : ''}\n                            ${arrow}\n                        </div>` : ''}\n                    </div>`);
            }
            if (zones.length) {
                zones.forEach(zone => {
                    cards.push(html `\n                    <div class="bg_white card card--event">\n                        <div class="container container--threetwo">\n                            <img src="${zone.photo1?.publicUrl ?? '/wp-content/themes/ace/assets/fallback_new.jpeg'}" alt="${zone.photo1?.altText ?? ''}" />\n                            <allin-alt-block description="${zone.photo1?.altText ?? ''}" uid="alt_photo1_${zone.id}"></allin-alt-block>\n                        </div>\n                        <div class="card-content">\n                            <a href="${this.hardlinks.listings_locations}/${location.id}/zone/${zone.id}${eventSearch}" class="card_target follow"><h3>${zone.name}</h3></a>\n                            ${arrow}\n                        </div>\n                    </div>`);
                });
            }
            if (!cards.length) {
                this.hideParent();
                return '';
            }
            else {
                this.showParent();
                return html `\n                    <div class="grid grid_25 gap cards">\n                        ${cards}\n                    </div>\n                `;
            }
        }
    }
    _updateEventData(e) {
        this.eventData = e.detail.eventData;
    }
    hideParent() {
        document.querySelector('#event-locations')?.classList.add('hide');
    }
    showParent() {
        document.querySelector('#event-locations')?.classList.remove('hide');
    }
    static styles = [
        accessibility,
        grid,
        containers,
        sidebar,
        css `
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }
        h2{
            color:var(--allin-highlight-color,#472961);
        }

        h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }
        .sidebar .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform: none !important;
            }
        }
        @media (min-width: 1000px) {
            .two_column{
                grid-template-rows:auto auto auto auto auto;
                grid-auto-flow:dense;
                column-gap:4rem;
            }
            aside{ 
                grid-row:1 / -1;
                grid-column:2 / 3;
            }
        }

        .card{
            background-color:#fff;
            display:grid;
            grid-template-rows:auto 1fr;
            img{
                transition:opacity var(--transition) ease;
            }
        }

        .card .card-content>svg{
            transition:transform var(--transition) ease;
            display:block;
            margin-left:auto;
        }

        .card-content{
            padding:1rem;
        }

        .card a{
            color:var(--allin-highlight-color,#472961);
            text-decoration-gap:0.25rem;
            text-decoration-thickness:1px;
            transition:text-decoration-thickness var(--transition) ease;
        }
        .card:hover img{
            opacity:0.9;
        } 
        /* First link hover effect only if second link is NOT hovered */
        .card:hover .card-content:not(:has(a.follow:hover)) > a.card_target {
            text-decoration-thickness: 2px;
        }

        /* Second link hover effect */
        .card-content a.follow:hover {
            text-decoration-thickness: 2px;
        }

        .card:hover .card-content>svg{
            transform:translateX(0.5rem);
        }

        .card-content{
            display:grid;
            grid-template-rows:auto auto auto 1fr auto;
        }

        .accessibility-icons{
            display:flex;
            gap:0.75rem;
            margin:3rem 0;
            flex-wrap:wrap;
        }
        .accessibility-icons li{
            width:1.5rem;
            height:1.5rem;
            path,circle,rect,polygon{
                fill:var(--allin-highlight-color,#472961);
            }

        }

        .loading{
            position:relative;
        }
        .loading::after{
            content:'';
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:3rem;
            height:3rem;
            border:4px solid var(--allin-highlight-color,#472961);
            border-top-color:transparent;
            border-radius:50%;
            animation:spin 1s linear infinite;
        }

        @keyframes spin {
            to { transform: translate(-50%,-50%) rotate(360deg); }
        }

        .return{
            margin-top:1rem;
        }
        @media (min-width:700px){
            .grid.grid_25{
                grid-template-columns:repeat(2,1fr);
            }
        }

        @media (min-width:1000px){
            .grid.grid_25{
                grid-template-columns:repeat(4,1fr);
            }
        }
        `
    ];
}
